import { BatchQueueImpl } from './batch-queue';
import { Hook } from '../hooks-manager';
export const batchPlugin = throttleDuration => _ref => {
  let {
    hooksManager,
    globalConfig,
    reporter
  } = _ref;
  if (globalConfig.getReporter()) {
    return;
  }
  globalConfig.initBatchQueue(new BatchQueueImpl({
    throttleDuration,
    flushHandler: reporter
  }));
  hooksManager.tap(Hook.beforeReport, eventPayload => {
    globalConfig.getBatchQueue().enqueue(eventPayload);
    return false;
  });
};
//# sourceMappingURL=batch-plugin.js.map